import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=46d816bf"
import script from "./FormButtons.vue?vue&type=script&lang=js"
export * from "./FormButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports